import type { Payment } from './types';

export type PayStatus = 'paid' | 'partial' | 'unpaid';

export interface PaymentState {
  price: number;
  /** Net received after refunds. */
  paid: number;
  refunded: number;
  due: number;
  status: PayStatus;
}

export function paymentState(price: number, payments: readonly Pick<Payment, 'amount'>[], refunded = 0): PaymentState {
  const grossPaid = payments.reduce((sum, p) => sum + p.amount, 0);
  const paid = Math.max(0, grossPaid - refunded);
  const due = Math.max(0, price - paid);
  const status: PayStatus = due === 0 ? 'paid' : paid === 0 ? 'unpaid' : 'partial';
  return { price, paid, refunded, due, status };
}

/** Rupees as "₹4,000" (Indian digit grouping). */
export function formatInr(amount: number): string {
  const n = Math.round(amount);
  const sign = n < 0 ? '-' : '';
  const s = String(Math.abs(n));
  if (s.length <= 3) return `${sign}₹${s}`;
  const last3 = s.slice(-3);
  const rest = s.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',');
  return `${sign}₹${rest},${last3}`;
}

/** A UPI deep link staff can paste or the customer can tap. */
export function upiLink(opts: { vpa: string; name: string; amount?: number; note?: string }): string {
  const p = new URLSearchParams();
  p.set('pa', opts.vpa);
  p.set('pn', opts.name);
  if (opts.amount && opts.amount > 0) p.set('am', String(Math.round(opts.amount)));
  p.set('cu', 'INR');
  if (opts.note) p.set('tn', opts.note);
  return `upi://pay?${p.toString()}`;
}
